import { IConfirmReparcelingDTO } from 'modules/customer/domain/dtos';
import { IReparcelingsRepository } from 'modules/customer/domain/repositories';

export class ConfirmReparcelingUseCase {
  constructor(private reparcelingsRepository: IReparcelingsRepository) {}

  public async execute({ hash, cash, installments }: IConfirmReparcelingDTO) {
    return this.reparcelingsRepository.update({
      hash,
      cash,
      installments,
    });
  }
}
